import date from "dayjs";
import "dayjs/locale/nl.js";
import IsSameOrAfter from "dayjs/plugin/isSameOrAfter";
import IsSameOrBefore from "dayjs/plugin/isSameOrBefore";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import weekday from "dayjs/plugin/weekday";
import isoWeek from "dayjs/plugin/isoWeek.js";

date.extend(LocalizedFormat);
date.extend(weekday);
date.extend(isoWeek);
date.extend(IsSameOrAfter);
date.extend(IsSameOrBefore);
date.locale("nl");

export default date;
